/*eslint-disable */
import Dashboard from "common/pages/Dashboard"
import CreacionFactura from "features/Crear/pages/CreacionFactura"
import MyAlbaranesAsReceptor from "features/Documentos/pages/Albaranes/MyAlbaranesAsReceptor"
import MyFacturasAsReceptor from "features/Documentos/pages/Facturas/MyFacturasAsReceptor"
import MyPedidosAsReceptor from "features/Documentos/pages/Pedidos/MyPedidosAsReceptor"
import MyPresupuestosAsReceptor from "features/Documentos/pages/Presupuestos/MyPresupuestosAsReceptor"
import Login from "features/User/pages/Login"
import LoginToken from "features/User/pages/LoginToken"
import { Route, BrowserRouter as Router, Switch } from "react-router-dom"

import ViewSharedCatalogo from "features/Inventario/pages/ViewSharedCatalogo"
import RecoveryPasswordStep1 from "features/User/pages/RecoveryPassword/RecoveryPasswordStep1"
import RecoveryPasswordStep2 from "features/User/pages/RecoveryPassword/RecoveryPasswordStep2"
import SharedEntryPoint from "../common/pages/gefintech/SharedEntryPoint"
import PrivateRoute from "./PrivateRoute"
import * as ROUTES from "./RoutePaths"

const CreateRoutes = () => {
  return (
    <Router>
      <Switch>
        <Route
          // @ts-expect-error TS(2322): Type '{ exact: true; path: string; component: () =...
          exact
          path={ROUTES.RECOVERY_PASSWORD_STEP_1}
          component={RecoveryPasswordStep1}
        />
        <Route
          // @ts-expect-error TS(2322): Type '{ exact: true; path: string; component: () =...
          exact
          path={ROUTES.RECOVERY_PASSWORD_STEP_2}
          component={RecoveryPasswordStep2}
        />
        <Route
          // @ts-expect-error TS(2322): Type '{ exact: true; path: string; component: () =...
          exact
          path={ROUTES.LOGIN_BACKUP}
          component={Login}
        />
        <Route
          // @ts-expect-error TS(2322): Type '{ exact: true; path: string; component: () =...
          exact
          path={ROUTES.LOGIN_INTERNO_BACKUP}
          component={Login}
        />
        <Route
          path='/facturaEmbed/:cif/:email/:identityId/:razonSocial/:libradorMdfId'
          // @ts-expect-error TS(2322): Type '{ path: string; component: () => Element; }'...
          component={CreacionFactura}
        />
        <Route
          // @ts-expect-error TS(2322): Type '{ exact: true; path: string; component: () =...
          exact
          path={ROUTES.VIEW_SHARED_CATALOGO}
          component={ViewSharedCatalogo}
        />
        <Route
          path='/misfacturas/:msgEncrypted'
          // @ts-expect-error TS(2322): Type '{ path: string; component: ({ history }: $TSFixMe...
          component={MyFacturasAsReceptor}
        />
        <Route
          path='/mispedidos/:msgEncrypted'
          // @ts-expect-error TS(2322): Type '{ path: string; component: ({ history }: $TSFixMe...
          component={MyPedidosAsReceptor}
        />
        <Route
          path='/mispresupuestos/:msgEncrypted'
          // @ts-expect-error TS(2322): Type '{ path: string; component: ({ history }: $TSFixMe...
          component={MyPresupuestosAsReceptor}
        />
        <Route
          path='/misalbaranes/:msgEncrypted'
          // @ts-expect-error TS(2322): Type '{ path: string; component: ({ history }: $TSFixMe...
          component={MyAlbaranesAsReceptor}
        />
        <Route
          path='/shared-entry-point'
          // @ts-expect-error TS(2322): Type '{ path: string; exact: true; component: () =...
          exact
          component={SharedEntryPoint}
        />
        <Route
          path={ROUTES.LOGIN_BACKUP}
          // @ts-expect-error TS(2322): Type '{ path: string; component: () => Element; }'...
          component={LoginToken}
        />
        <PrivateRoute
          path={ROUTES.DASHBOARD}
          component={Dashboard}
        />
      </Switch>
    </Router>
  )
}

export default CreateRoutes
